module.exports = __webpack_public_path__ + "img/DE01012.91f391eb.png";